import styled from "styled-components";

interface isActive {
    active?: boolean;
}

export const InformationComponent = styled.div`
    width: 100%;
    display: flex;
    @media only screen and (max-width: 1000px) {
        padding: 1%;
    }
    padding: 1%;
`;

export const InformationContent = styled.div`
    display: flex;
    justify-content: left;
    flex-direction: column;
    width: 100%;
`;

export const LogoDiv = styled.div`
    @media only screen and (max-width: 1000px) {
       display: flex;
       align-items: center;
       justify-content: center;
    }
`;

export const Logo = styled.img`
    display: flex;
    align-items: center;
`;

export const InformationText = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-family: "Poppins";
    margin: 0% 2%;
    color:  #2f185b;
    font-weight: 600;
`;

export const SearchDiv = styled.div``;


export const TextComponent = styled.div`
    display: flex;
    flex-direction: row;
    margin: 5px;
`;


export const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    color: black;
    margin-left: 10px;
    h1 {
        font-size: 20px;
        color: var(--title-higlight);
        font-family: "Montserrat", Sans-serif;
        font-weight: normal;
    }

    p {
        font-size: 16px;
        color: var(--text);
        font-weight: normal;
        font-family: "Montserrat", Sans-serif;
    }
    @media only screen and (max-width: 1000px) {
        h1 {
            font-size: 18px;
        }

        p {
            font-size: 14px;
        }
    }
`;

export const TextLogo = styled.div`
    margin: 5px;
    display: flex;
    justify-content: center;
    color: var(--setra-blue);
`;

export const IconsDiv = styled.div`
    padding: 1px;
`;
